import type { ParticipantEmbeddableForm } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantEmbeddableFormDeleteModal } from './ParticipantEmbeddableFormDeleteModal';
import { ParticipantEmbeddableFormEditModal } from './ParticipantEmbeddableFormEditModal';

interface Props {
  isDisabled?: boolean;
  form: ParticipantEmbeddableForm;
  participantId: string;
}

export const ParticipantEmbeddableFormActionsMenu = (props: Props) => {
  const { isDisabled, form, participantId, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button disabled={isDisabled} variant='plain' size='sm' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantEmbeddableFormEditModal, {
                form,
                participantId,
              })
            }
            disabled={isDisabled}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantEmbeddableFormDeleteModal, {
                participantId,
                participantEmbeddableFormId: form.id,
                participantEmbeddableFormName: form.name,
              })
            }
            color='danger'
            disabled={isDisabled}
            value='delete'
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
